import { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "moment/locale/pt-br";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Plus, X, Save } from "lucide-react";
import "./Agenda.css";

const localizer = momentLocalizer(moment);

export default function Agenda() {
    const [events, setEvents] = useState(() => {
        const saved = localStorage.getItem("myWorkspaceAgenda");
        if (saved) {
            return JSON.parse(saved).map(ev => ({
                ...ev,
                start: new Date(ev.start),
                end: new Date(ev.end)
            }));
        }
        return [];
    });

    const [showModal, setShowModal] = useState(false);
    const [newEvent, setNewEvent] = useState({ title: "", start: null, end: null, type: "work" });

    useEffect(() => {
        localStorage.setItem("myWorkspaceAgenda", JSON.stringify(events));
    }, [events]);

    const handleSelectSlot = (slotInfo) => {
        setNewEvent({
            title: "",
            start: slotInfo.start,
            end: slotInfo.end,
            type: "work"
        });
        setShowModal(true);
    };

    const handleSelectEvent = (event) => {
        if (window.confirm(`Deseja excluir o evento "${event.title}"?`)) {
            setEvents(events.filter(e => e.id !== event.id));
        }
    };

    const handleSaveEvent = () => {
        if (!newEvent.title) return;
        setEvents([
            ...events,
            { ...newEvent, id: Date.now() }
        ]);
        setShowModal(false);
    };

    const eventStyleGetter = (event) => {
        let backgroundColor = "#3174ad";
        if (event.type === "personal") backgroundColor = "#10b981";
        if (event.type === "study") backgroundColor = "#8b5cf6";
        if (event.type === "important") backgroundColor = "#ef4444";

        return {
            style: {
                backgroundColor,
                borderRadius: "4px",
                opacity: 0.8,
                color: "white",
                border: "0px",
                display: "block"
            }
        };
    };

    return (
        <div className="agenda-container">
            <header className="agenda-header">
                <div>
                    <h1>Minha Agenda</h1>
                    <p>Organize seus compromissos e time-blocking.</p>
                </div>
                <button className="btn-add-event" onClick={() => {
                    setNewEvent({ title: "", start: new Date(), end: new Date(), type: "work" });
                    setShowModal(true);
                }}>
                    <Plus size={20} /> Novo Evento
                </button>
            </header>

            <div className="calendar-wrapper">
                <Calendar
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    style={{ height: "100%" }}
                    selectable
                    onSelectSlot={handleSelectSlot}
                    onSelectEvent={handleSelectEvent}
                    eventPropGetter={eventStyleGetter}
                    messages={{
                        next: "Próximo",
                        previous: "Anterior",
                        today: "Hoje",
                        month: "Mês",
                        week: "Semana",
                        day: "Dia",
                        agenda: "Agenda",
                        date: "Data",
                        time: "Hora",
                        event: "Evento",
                        noEventsInRange: "Sem eventos neste período."
                    }}
                    views={['month', 'week', 'day', 'agenda']}
                    defaultView="month"
                />
            </div>

            {showModal && (
                <div className="agenda-modal-overlay">
                    <div className="agenda-modal-box">
                        <div className="agenda-modal-header">
                            <h3>Novo Compromisso</h3>
                            <button onClick={() => setShowModal(false)} className="btn-close">
                                <X size={20} />
                            </button>
                        </div>

                        <div className="form-group">
                            <label>Título</label>
                            <input
                                autoFocus
                                type="text"
                                value={newEvent.title}
                                onChange={e => setNewEvent({ ...newEvent, title: e.target.value })}
                                placeholder="Ex: Reunião de Projeto"
                            />
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Início</label>
                                <span className="date-display">
                                    {moment(newEvent.start).format("DD/MM/YYYY HH:mm")}
                                </span>
                            </div>
                            <div className="form-group">
                                <label>Fim</label>
                                <span className="date-display">
                                    {moment(newEvent.end).format("DD/MM/YYYY HH:mm")}
                                </span>
                            </div>
                        </div>

                        <div className="form-group">
                            <label>Categoria</label>
                            <select
                                value={newEvent.type}
                                onChange={e => setNewEvent({ ...newEvent, type: e.target.value })}
                            >
                                <option value="work">Trabalho (Azul)</option>
                                <option value="personal">Pessoal (Verde)</option>
                                <option value="study">Estudos (Roxo)</option>
                                <option value="important">Importante (Vermelho)</option>
                            </select>
                        </div>

                        <div className="agenda-modal-actions">
                            <button onClick={handleSaveEvent} className="btn-save-event">
                                <Save size={18} /> Salvar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}